/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EndLeaseIn,
  HTTPValidationError,
  LateFeeRuleIn,
  LateFeeRuleOut,
  LeaseCreateIn,
  LeaseLedgerOut,
  LeaseOut,
  LeaseTermsIn,
  ListLeasesParams,
  MessageResponse,
  OneTimeChargeIn,
  PaginatedLeaseOut,
  RecurringChargeIn,
  RecurringChargeOut,
  RecurringChargesOut,
  SetLeaseResidentsIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listLeasesResponse200 = {
  data: PaginatedLeaseOut
  status: 200
}

export type listLeasesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listLeasesResponseSuccess = (listLeasesResponse200) & {
  headers: Headers;
};
export type listLeasesResponseError = (listLeasesResponse422) & {
  headers: Headers;
};

export type listLeasesResponse = (listLeasesResponseSuccess | listLeasesResponseError)

export const getListLeasesUrl = (params?: ListLeasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leases?${stringifiedParams}` : `/api/leases`
}

/**
 * @summary List Leases
 */
export const listLeases = async (params?: ListLeasesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listLeasesResponse> => {

  return apiFetch<listLeasesResponse>(getListLeasesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeasesQueryKey = (params?: ListLeasesParams,) => {
    return [
    `/api/leases`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeasesQueryOptions = <TData = Awaited<ReturnType<typeof listLeases>>, TError = HTTPValidationError>(params?: ListLeasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeasesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeases>>> = ({ signal }) => listLeases(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLeasesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeases>>>
export type ListLeasesQueryError = HTTPValidationError


export function useListLeases<TData = Awaited<ReturnType<typeof listLeases>>, TError = HTTPValidationError>(
 params: undefined |  ListLeasesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeases>>,
          TError,
          Awaited<ReturnType<typeof listLeases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeases<TData = Awaited<ReturnType<typeof listLeases>>, TError = HTTPValidationError>(
 params?: ListLeasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeases>>,
          TError,
          Awaited<ReturnType<typeof listLeases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeases<TData = Awaited<ReturnType<typeof listLeases>>, TError = HTTPValidationError>(
 params?: ListLeasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Leases
 */

export function useListLeases<TData = Awaited<ReturnType<typeof listLeases>>, TError = HTTPValidationError>(
 params?: ListLeasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLeasesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createLeaseResponse201 = {
  data: LeaseOut
  status: 201
}

export type createLeaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createLeaseResponseSuccess = (createLeaseResponse201) & {
  headers: Headers;
};
export type createLeaseResponseError = (createLeaseResponse422) & {
  headers: Headers;
};

export type createLeaseResponse = (createLeaseResponseSuccess | createLeaseResponseError)

export const getCreateLeaseUrl = () => {




  return `/api/leases`
}

/**
 * @summary Create Lease
 */
export const createLease = async (leaseCreateIn: LeaseCreateIn, options?: Parameters<typeof apiFetch>[1]): Promise<createLeaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createLeaseResponse>(getCreateLeaseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(leaseCreateIn)
  }
);}





export const getCreateLeaseMutationKey = () => ['createLease'] as const;

export const getCreateLeaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLease>>, TError,CreateLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLease>>, TError,CreateLeaseMutationVariables, TContext> => {

const mutationKey = getCreateLeaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLease>>, CreateLeaseMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLease(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeaseMutationResult = NonNullable<Awaited<ReturnType<typeof createLease>>>
    export type CreateLeaseMutationBody = LeaseCreateIn
    export type CreateLeaseMutationError = HTTPValidationError
    export type CreateLeaseMutationVariables = {data: LeaseCreateIn}

    /**
 * @summary Create Lease
 */
export const useCreateLease = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLease>>, TError,CreateLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLease>>,
        TError,
        CreateLeaseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLeaseMutationOptions(options), queryClient);
    }
    export type getLeaseResponse200 = {
  data: LeaseOut
  status: 200
}

export type getLeaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getLeaseResponseSuccess = (getLeaseResponse200) & {
  headers: Headers;
};
export type getLeaseResponseError = (getLeaseResponse422) & {
  headers: Headers;
};

export type getLeaseResponse = (getLeaseResponseSuccess | getLeaseResponseError)

export const getGetLeaseUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}`
}

/**
 * @summary Get Lease
 */
export const getLease = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getLeaseResponse> => {

  return apiFetch<getLeaseResponse>(getGetLeaseUrl(leaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeaseQueryKey = (leaseId: number,) => {
    return [
    `/api/leases/${leaseId}`
    ] as const;
    }


export const getGetLeaseQueryOptions = <TData = Awaited<ReturnType<typeof getLease>>, TError = HTTPValidationError>(leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeaseQueryKey(leaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLease>>> = ({ signal }) => getLease(leaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leaseId !== null && leaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeaseQueryResult = NonNullable<Awaited<ReturnType<typeof getLease>>>
export type GetLeaseQueryError = HTTPValidationError


export function useGetLease<TData = Awaited<ReturnType<typeof getLease>>, TError = HTTPValidationError>(
 leaseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLease>>,
          TError,
          Awaited<ReturnType<typeof getLease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLease<TData = Awaited<ReturnType<typeof getLease>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLease>>,
          TError,
          Awaited<ReturnType<typeof getLease>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLease<TData = Awaited<ReturnType<typeof getLease>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lease
 */

export function useGetLease<TData = Awaited<ReturnType<typeof getLease>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLease>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeaseQueryOptions(leaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateLeaseResponse200 = {
  data: LeaseOut
  status: 200
}

export type updateLeaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateLeaseResponseSuccess = (updateLeaseResponse200) & {
  headers: Headers;
};
export type updateLeaseResponseError = (updateLeaseResponse422) & {
  headers: Headers;
};

export type updateLeaseResponse = (updateLeaseResponseSuccess | updateLeaseResponseError)

export const getUpdateLeaseUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}`
}

/**
 * @summary Update Lease
 */
export const updateLease = async (leaseId: number,
    leaseTermsIn: LeaseTermsIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateLeaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateLeaseResponse>(getUpdateLeaseUrl(leaseId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(leaseTermsIn)
  }
);}





export const getUpdateLeaseMutationKey = () => ['updateLease'] as const;

export const getUpdateLeaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLease>>, TError,UpdateLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLease>>, TError,UpdateLeaseMutationVariables, TContext> => {

const mutationKey = getUpdateLeaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLease>>, UpdateLeaseMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  updateLease(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeaseMutationResult = NonNullable<Awaited<ReturnType<typeof updateLease>>>
    export type UpdateLeaseMutationBody = LeaseTermsIn
    export type UpdateLeaseMutationError = HTTPValidationError
    export type UpdateLeaseMutationVariables = {leaseId: number;data: LeaseTermsIn}

    /**
 * @summary Update Lease
 */
export const useUpdateLease = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLease>>, TError,UpdateLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLease>>,
        TError,
        UpdateLeaseMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLeaseMutationOptions(options), queryClient);
    }
    export type deleteLeaseResponse204 = {
  data: void
  status: 204
}

export type deleteLeaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteLeaseResponseSuccess = (deleteLeaseResponse204) & {
  headers: Headers;
};
export type deleteLeaseResponseError = (deleteLeaseResponse422) & {
  headers: Headers;
};

export type deleteLeaseResponse = (deleteLeaseResponseSuccess | deleteLeaseResponseError)

export const getDeleteLeaseUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}`
}

/**
 * @summary Delete Lease
 */
export const deleteLease = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteLeaseResponse> => {

  return apiFetch<deleteLeaseResponse>(getDeleteLeaseUrl(leaseId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLeaseMutationKey = () => ['deleteLease'] as const;

export const getDeleteLeaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLease>>, TError,DeleteLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLease>>, TError,DeleteLeaseMutationVariables, TContext> => {

const mutationKey = getDeleteLeaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLease>>, DeleteLeaseMutationVariables> = (props) => {
          const {leaseId} = props ?? {};

          return  deleteLease(leaseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLease>>>

    export type DeleteLeaseMutationError = HTTPValidationError
    export type DeleteLeaseMutationVariables = {leaseId: number}

    /**
 * @summary Delete Lease
 */
export const useDeleteLease = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLease>>, TError,DeleteLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLease>>,
        TError,
        DeleteLeaseMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLeaseMutationOptions(options), queryClient);
    }
    export type endLeaseResponse200 = {
  data: LeaseOut
  status: 200
}

export type endLeaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type endLeaseResponseSuccess = (endLeaseResponse200) & {
  headers: Headers;
};
export type endLeaseResponseError = (endLeaseResponse422) & {
  headers: Headers;
};

export type endLeaseResponse = (endLeaseResponseSuccess | endLeaseResponseError)

export const getEndLeaseUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/end`
}

/**
 * @summary End Lease
 */
export const endLease = async (leaseId: number,
    endLeaseIn: EndLeaseIn, options?: Parameters<typeof apiFetch>[1]): Promise<endLeaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<endLeaseResponse>(getEndLeaseUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(endLeaseIn)
  }
);}





export const getEndLeaseMutationKey = () => ['endLease'] as const;

export const getEndLeaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endLease>>, TError,EndLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endLease>>, TError,EndLeaseMutationVariables, TContext> => {

const mutationKey = getEndLeaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endLease>>, EndLeaseMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  endLease(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndLeaseMutationResult = NonNullable<Awaited<ReturnType<typeof endLease>>>
    export type EndLeaseMutationBody = EndLeaseIn
    export type EndLeaseMutationError = HTTPValidationError
    export type EndLeaseMutationVariables = {leaseId: number;data: EndLeaseIn}

    /**
 * @summary End Lease
 */
export const useEndLease = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endLease>>, TError,EndLeaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endLease>>,
        TError,
        EndLeaseMutationVariables,
        TContext
      > => {
      return useMutation(getEndLeaseMutationOptions(options), queryClient);
    }
    export type setLeaseResidentsResponse200 = {
  data: LeaseOut
  status: 200
}

export type setLeaseResidentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setLeaseResidentsResponseSuccess = (setLeaseResidentsResponse200) & {
  headers: Headers;
};
export type setLeaseResidentsResponseError = (setLeaseResidentsResponse422) & {
  headers: Headers;
};

export type setLeaseResidentsResponse = (setLeaseResidentsResponseSuccess | setLeaseResidentsResponseError)

export const getSetLeaseResidentsUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/residents`
}

/**
 * @summary Set Lease Residents
 */
export const setLeaseResidents = async (leaseId: number,
    setLeaseResidentsIn: SetLeaseResidentsIn, options?: Parameters<typeof apiFetch>[1]): Promise<setLeaseResidentsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setLeaseResidentsResponse>(getSetLeaseResidentsUrl(leaseId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setLeaseResidentsIn)
  }
);}





export const getSetLeaseResidentsMutationKey = () => ['setLeaseResidents'] as const;

export const getSetLeaseResidentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeaseResidents>>, TError,SetLeaseResidentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLeaseResidents>>, TError,SetLeaseResidentsMutationVariables, TContext> => {

const mutationKey = getSetLeaseResidentsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLeaseResidents>>, SetLeaseResidentsMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  setLeaseResidents(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLeaseResidentsMutationResult = NonNullable<Awaited<ReturnType<typeof setLeaseResidents>>>
    export type SetLeaseResidentsMutationBody = SetLeaseResidentsIn
    export type SetLeaseResidentsMutationError = HTTPValidationError
    export type SetLeaseResidentsMutationVariables = {leaseId: number;data: SetLeaseResidentsIn}

    /**
 * @summary Set Lease Residents
 */
export const useSetLeaseResidents = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeaseResidents>>, TError,SetLeaseResidentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLeaseResidents>>,
        TError,
        SetLeaseResidentsMutationVariables,
        TContext
      > => {
      return useMutation(getSetLeaseResidentsMutationOptions(options), queryClient);
    }
    export type getLeaseLedgerResponse200 = {
  data: LeaseLedgerOut
  status: 200
}

export type getLeaseLedgerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getLeaseLedgerResponseSuccess = (getLeaseLedgerResponse200) & {
  headers: Headers;
};
export type getLeaseLedgerResponseError = (getLeaseLedgerResponse422) & {
  headers: Headers;
};

export type getLeaseLedgerResponse = (getLeaseLedgerResponseSuccess | getLeaseLedgerResponseError)

export const getGetLeaseLedgerUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/ledger`
}

/**
 * @summary Get Lease Ledger
 */
export const getLeaseLedger = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getLeaseLedgerResponse> => {

  return apiFetch<getLeaseLedgerResponse>(getGetLeaseLedgerUrl(leaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeaseLedgerQueryKey = (leaseId: number,) => {
    return [
    `/api/leases/${leaseId}/ledger`
    ] as const;
    }


export const getGetLeaseLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getLeaseLedger>>, TError = HTTPValidationError>(leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeaseLedgerQueryKey(leaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaseLedger>>> = ({ signal }) => getLeaseLedger(leaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leaseId !== null && leaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeaseLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getLeaseLedger>>>
export type GetLeaseLedgerQueryError = HTTPValidationError


export function useGetLeaseLedger<TData = Awaited<ReturnType<typeof getLeaseLedger>>, TError = HTTPValidationError>(
 leaseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeaseLedger>>,
          TError,
          Awaited<ReturnType<typeof getLeaseLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeaseLedger<TData = Awaited<ReturnType<typeof getLeaseLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeaseLedger>>,
          TError,
          Awaited<ReturnType<typeof getLeaseLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeaseLedger<TData = Awaited<ReturnType<typeof getLeaseLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Lease Ledger
 */

export function useGetLeaseLedger<TData = Awaited<ReturnType<typeof getLeaseLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeaseLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeaseLedgerQueryOptions(leaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type addLeaseChargeResponse200 = {
  data: MessageResponse
  status: 200
}

export type addLeaseChargeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addLeaseChargeResponseSuccess = (addLeaseChargeResponse200) & {
  headers: Headers;
};
export type addLeaseChargeResponseError = (addLeaseChargeResponse422) & {
  headers: Headers;
};

export type addLeaseChargeResponse = (addLeaseChargeResponseSuccess | addLeaseChargeResponseError)

export const getAddLeaseChargeUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/charges`
}

/**
 * @summary Add Lease Charge
 */
export const addLeaseCharge = async (leaseId: number,
    oneTimeChargeIn: OneTimeChargeIn, options?: Parameters<typeof apiFetch>[1]): Promise<addLeaseChargeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addLeaseChargeResponse>(getAddLeaseChargeUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(oneTimeChargeIn)
  }
);}





export const getAddLeaseChargeMutationKey = () => ['addLeaseCharge'] as const;

export const getAddLeaseChargeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeaseCharge>>, TError,AddLeaseChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addLeaseCharge>>, TError,AddLeaseChargeMutationVariables, TContext> => {

const mutationKey = getAddLeaseChargeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLeaseCharge>>, AddLeaseChargeMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  addLeaseCharge(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddLeaseChargeMutationResult = NonNullable<Awaited<ReturnType<typeof addLeaseCharge>>>
    export type AddLeaseChargeMutationBody = OneTimeChargeIn
    export type AddLeaseChargeMutationError = HTTPValidationError
    export type AddLeaseChargeMutationVariables = {leaseId: number;data: OneTimeChargeIn}

    /**
 * @summary Add Lease Charge
 */
export const useAddLeaseCharge = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLeaseCharge>>, TError,AddLeaseChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLeaseCharge>>,
        TError,
        AddLeaseChargeMutationVariables,
        TContext
      > => {
      return useMutation(getAddLeaseChargeMutationOptions(options), queryClient);
    }
    export type listRecurringChargesResponse200 = {
  data: RecurringChargesOut
  status: 200
}

export type listRecurringChargesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listRecurringChargesResponseSuccess = (listRecurringChargesResponse200) & {
  headers: Headers;
};
export type listRecurringChargesResponseError = (listRecurringChargesResponse422) & {
  headers: Headers;
};

export type listRecurringChargesResponse = (listRecurringChargesResponseSuccess | listRecurringChargesResponseError)

export const getListRecurringChargesUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/recurring-charges`
}

/**
 * @summary List Recurring Charges
 */
export const listRecurringCharges = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<listRecurringChargesResponse> => {

  return apiFetch<listRecurringChargesResponse>(getListRecurringChargesUrl(leaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecurringChargesQueryKey = (leaseId: number,) => {
    return [
    `/api/leases/${leaseId}/recurring-charges`
    ] as const;
    }


export const getListRecurringChargesQueryOptions = <TData = Awaited<ReturnType<typeof listRecurringCharges>>, TError = HTTPValidationError>(leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecurringChargesQueryKey(leaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecurringCharges>>> = ({ signal }) => listRecurringCharges(leaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leaseId !== null && leaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecurringChargesQueryResult = NonNullable<Awaited<ReturnType<typeof listRecurringCharges>>>
export type ListRecurringChargesQueryError = HTTPValidationError


export function useListRecurringCharges<TData = Awaited<ReturnType<typeof listRecurringCharges>>, TError = HTTPValidationError>(
 leaseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecurringCharges>>,
          TError,
          Awaited<ReturnType<typeof listRecurringCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecurringCharges<TData = Awaited<ReturnType<typeof listRecurringCharges>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecurringCharges>>,
          TError,
          Awaited<ReturnType<typeof listRecurringCharges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecurringCharges<TData = Awaited<ReturnType<typeof listRecurringCharges>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Recurring Charges
 */

export function useListRecurringCharges<TData = Awaited<ReturnType<typeof listRecurringCharges>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecurringCharges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecurringChargesQueryOptions(leaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type addRecurringChargeResponse201 = {
  data: RecurringChargeOut
  status: 201
}

export type addRecurringChargeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addRecurringChargeResponseSuccess = (addRecurringChargeResponse201) & {
  headers: Headers;
};
export type addRecurringChargeResponseError = (addRecurringChargeResponse422) & {
  headers: Headers;
};

export type addRecurringChargeResponse = (addRecurringChargeResponseSuccess | addRecurringChargeResponseError)

export const getAddRecurringChargeUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/recurring-charges`
}

/**
 * @summary Add Recurring Charge
 */
export const addRecurringCharge = async (leaseId: number,
    recurringChargeIn: RecurringChargeIn, options?: Parameters<typeof apiFetch>[1]): Promise<addRecurringChargeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addRecurringChargeResponse>(getAddRecurringChargeUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recurringChargeIn)
  }
);}





export const getAddRecurringChargeMutationKey = () => ['addRecurringCharge'] as const;

export const getAddRecurringChargeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRecurringCharge>>, TError,AddRecurringChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addRecurringCharge>>, TError,AddRecurringChargeMutationVariables, TContext> => {

const mutationKey = getAddRecurringChargeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRecurringCharge>>, AddRecurringChargeMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  addRecurringCharge(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddRecurringChargeMutationResult = NonNullable<Awaited<ReturnType<typeof addRecurringCharge>>>
    export type AddRecurringChargeMutationBody = RecurringChargeIn
    export type AddRecurringChargeMutationError = HTTPValidationError
    export type AddRecurringChargeMutationVariables = {leaseId: number;data: RecurringChargeIn}

    /**
 * @summary Add Recurring Charge
 */
export const useAddRecurringCharge = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRecurringCharge>>, TError,AddRecurringChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addRecurringCharge>>,
        TError,
        AddRecurringChargeMutationVariables,
        TContext
      > => {
      return useMutation(getAddRecurringChargeMutationOptions(options), queryClient);
    }
    export type removeRecurringChargeResponse204 = {
  data: void
  status: 204
}

export type removeRecurringChargeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeRecurringChargeResponseSuccess = (removeRecurringChargeResponse204) & {
  headers: Headers;
};
export type removeRecurringChargeResponseError = (removeRecurringChargeResponse422) & {
  headers: Headers;
};

export type removeRecurringChargeResponse = (removeRecurringChargeResponseSuccess | removeRecurringChargeResponseError)

export const getRemoveRecurringChargeUrl = (leaseId: number,
    chargeId: number,) => {




  return `/api/leases/${leaseId}/recurring-charges/${chargeId}`
}

/**
 * @summary Remove Recurring Charge
 */
export const removeRecurringCharge = async (leaseId: number,
    chargeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<removeRecurringChargeResponse> => {

  return apiFetch<removeRecurringChargeResponse>(getRemoveRecurringChargeUrl(leaseId,chargeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveRecurringChargeMutationKey = () => ['removeRecurringCharge'] as const;

export const getRemoveRecurringChargeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRecurringCharge>>, TError,RemoveRecurringChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeRecurringCharge>>, TError,RemoveRecurringChargeMutationVariables, TContext> => {

const mutationKey = getRemoveRecurringChargeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeRecurringCharge>>, RemoveRecurringChargeMutationVariables> = (props) => {
          const {leaseId,chargeId} = props ?? {};

          return  removeRecurringCharge(leaseId,chargeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveRecurringChargeMutationResult = NonNullable<Awaited<ReturnType<typeof removeRecurringCharge>>>

    export type RemoveRecurringChargeMutationError = HTTPValidationError
    export type RemoveRecurringChargeMutationVariables = {leaseId: number;chargeId: number}

    /**
 * @summary Remove Recurring Charge
 */
export const useRemoveRecurringCharge = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeRecurringCharge>>, TError,RemoveRecurringChargeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeRecurringCharge>>,
        TError,
        RemoveRecurringChargeMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveRecurringChargeMutationOptions(options), queryClient);
    }
    export type getLateFeeRuleResponse200 = {
  data: LateFeeRuleOut
  status: 200
}

export type getLateFeeRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getLateFeeRuleResponseSuccess = (getLateFeeRuleResponse200) & {
  headers: Headers;
};
export type getLateFeeRuleResponseError = (getLateFeeRuleResponse422) & {
  headers: Headers;
};

export type getLateFeeRuleResponse = (getLateFeeRuleResponseSuccess | getLateFeeRuleResponseError)

export const getGetLateFeeRuleUrl = (propertyId: number,) => {




  return `/api/properties/${propertyId}/late-fee-rule`
}

/**
 * @summary Get Late Fee Rule
 */
export const getLateFeeRule = async (propertyId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getLateFeeRuleResponse> => {

  return apiFetch<getLateFeeRuleResponse>(getGetLateFeeRuleUrl(propertyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLateFeeRuleQueryKey = (propertyId: number,) => {
    return [
    `/api/properties/${propertyId}/late-fee-rule`
    ] as const;
    }


export const getGetLateFeeRuleQueryOptions = <TData = Awaited<ReturnType<typeof getLateFeeRule>>, TError = HTTPValidationError>(propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLateFeeRuleQueryKey(propertyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLateFeeRule>>> = ({ signal }) => getLateFeeRule(propertyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: propertyId !== null && propertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLateFeeRuleQueryResult = NonNullable<Awaited<ReturnType<typeof getLateFeeRule>>>
export type GetLateFeeRuleQueryError = HTTPValidationError


export function useGetLateFeeRule<TData = Awaited<ReturnType<typeof getLateFeeRule>>, TError = HTTPValidationError>(
 propertyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLateFeeRule>>,
          TError,
          Awaited<ReturnType<typeof getLateFeeRule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLateFeeRule<TData = Awaited<ReturnType<typeof getLateFeeRule>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLateFeeRule>>,
          TError,
          Awaited<ReturnType<typeof getLateFeeRule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLateFeeRule<TData = Awaited<ReturnType<typeof getLateFeeRule>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Late Fee Rule
 */

export function useGetLateFeeRule<TData = Awaited<ReturnType<typeof getLateFeeRule>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateFeeRule>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLateFeeRuleQueryOptions(propertyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setLateFeeRuleResponse200 = {
  data: LateFeeRuleOut
  status: 200
}

export type setLateFeeRuleResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setLateFeeRuleResponseSuccess = (setLateFeeRuleResponse200) & {
  headers: Headers;
};
export type setLateFeeRuleResponseError = (setLateFeeRuleResponse422) & {
  headers: Headers;
};

export type setLateFeeRuleResponse = (setLateFeeRuleResponseSuccess | setLateFeeRuleResponseError)

export const getSetLateFeeRuleUrl = (propertyId: number,) => {




  return `/api/properties/${propertyId}/late-fee-rule`
}

/**
 * @summary Set Late Fee Rule
 */
export const setLateFeeRule = async (propertyId: number,
    lateFeeRuleIn: LateFeeRuleIn, options?: Parameters<typeof apiFetch>[1]): Promise<setLateFeeRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setLateFeeRuleResponse>(getSetLateFeeRuleUrl(propertyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lateFeeRuleIn)
  }
);}





export const getSetLateFeeRuleMutationKey = () => ['setLateFeeRule'] as const;

export const getSetLateFeeRuleMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLateFeeRule>>, TError,SetLateFeeRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLateFeeRule>>, TError,SetLateFeeRuleMutationVariables, TContext> => {

const mutationKey = getSetLateFeeRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLateFeeRule>>, SetLateFeeRuleMutationVariables> = (props) => {
          const {propertyId,data} = props ?? {};

          return  setLateFeeRule(propertyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLateFeeRuleMutationResult = NonNullable<Awaited<ReturnType<typeof setLateFeeRule>>>
    export type SetLateFeeRuleMutationBody = LateFeeRuleIn
    export type SetLateFeeRuleMutationError = HTTPValidationError
    export type SetLateFeeRuleMutationVariables = {propertyId: number;data: LateFeeRuleIn}

    /**
 * @summary Set Late Fee Rule
 */
export const useSetLateFeeRule = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLateFeeRule>>, TError,SetLateFeeRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLateFeeRule>>,
        TError,
        SetLateFeeRuleMutationVariables,
        TContext
      > => {
      return useMutation(getSetLateFeeRuleMutationOptions(options), queryClient);
    }
